import React, { useEffect, useState } from "react";
import axios from "axios";
import { useLocation } from "react-router-dom";

// Product List Components
import PaymentPage0 from "./PaymentPage0";

const PaymentPage = () => {
  const [paymentPageNo, setpaymentPageNo] = useState(null);
  const [data, setData] = useState([]);
  const location = useLocation();
  const {
    address,
    selectedDeliveryPrice,
    selectedTimeslot,
    selectedDate,
    deliveryType,
    handlingCharges,
    rainSurgeCharge,
    giftWrapFee,
    donationFee,
    tip,
  } = location.state || {};

  const user_auto_id = sessionStorage.getItem("accessToken");

  useEffect(() => {
    const storedStyle = sessionStorage.getItem("UIStyle");
    if (storedStyle) {
      const parsedStyle = JSON.parse(storedStyle);
      setpaymentPageNo(parseInt(parsedStyle.cart_layout_no));
    }
  }, []);

  const fetchCartList = async () => {
    try {
      setData([]);
      const formData = new FormData();
      formData.append("user_auto_id", user_auto_id);
      formData.append("admin_auto_id", sessionStorage.getItem("admin_auto_id"));
      formData.append("limit", "10");
      formData.append("page_number", "1");
      formData.append("app_type_id", sessionStorage.getItem("app_type_id"));

      if (address?.pincode) {
        formData.append("pincode", address.pincode);
      }

      if (selectedTimeslot) {
        formData.append("delivery_time", selectedTimeslot);
      }

      if (deliveryType) {
        const formattedDeliveryType =
          deliveryType === "Normal Delivery"
            ? "Normal"
            : deliveryType === "Express Delivery"
            ? "Express"
            : deliveryType;
        formData.append("delivery_type", formattedDeliveryType);
      }

      const response = await axios.post(
        "https://gruzen.in/GrobizEcommerceAppBuilder/api/get_cart_list",
        formData
      );

      if (response.data.status === 1) {
        const { status, ...restData } = response.data;
        setData(restData);
      }
    } catch (error) {
      console.error("Error fetching products:", error);
    }
  };

  useEffect(() => {
    fetchCartList();
  }, [user_auto_id]);

  // Mapping cartNo to Components
  const paymentComponents = {
    0: PaymentPage0,
  };

  const SelectedPayment = paymentComponents[paymentPageNo];

  return (
    <div>
      {SelectedPayment && (
        <SelectedPayment
          data={data}
          address={address}
          selectedDeliveryPrice={selectedDeliveryPrice}
          selectedDate={selectedDate}
          selectedTimeslot={selectedTimeslot}
          deliveryType={deliveryType}
          handlingCharges={handlingCharges}
          rainSurgeCharge={rainSurgeCharge}
          giftWrapFee={giftWrapFee}
          donationFee={donationFee}
          tip={tip}
        />
      )}
    </div>
  );
};

export default PaymentPage;
